import { ErrorCode } from '@afterpaytouch/portal-api/types'
import { FetchVerificationErrorResponse, FetchVerificationWaitResponse } from '@afterpaytouch/event-verify'
import {
  RegistrationId,
  RegistrationData,
  CreateAccountRequest,
  registrationErrors as regErrors,
  CreateRegistration,
  CreateRegistrationRequest,
  CreateRegistrationResponse,
  TransformedCreateRegistrationResponse,
  RegistrationErrorCode,
} from '@afterpaytouch/registration'
export { RegistrationErrorCode }

export const registrationErrors = regErrors

export type {
  CreateAccountRequest,
  CreateRegistration,
  CreateRegistrationRequest,
  CreateRegistrationResponse,
  TransformedCreateRegistrationResponse,
  RegistrationData,
}

export enum RegistrationStatus {
  NotStarted,
  Created,
  CodeSent,
  CodeVerified,
  Completed,
  IDVerified,
  ContractAgreementAccepted,
  Error,
}

export const duplicateErrorCodeList: RegistrationErrorCode[] = [RegistrationErrorCode.ExistingPhoneNumberSendEmail, RegistrationErrorCode.ExistingPhoneNumber]

export interface RegistrationError {
  error: RegistrationErrorCode
  errorCode?: ErrorCode
  errorInfo?: unknown
}

export interface VerifyRegistrationMobileEventRequest {
  onSuccess: () => void
  onError: (d: FetchVerificationErrorResponse) => void
  onWaiting: (d: FetchVerificationWaitResponse) => void
}

export interface VerifyRegistrationAuthorizationRequest {
  registrationId: RegistrationId
  amplitudeSessionId: number
  consumer: RegistrationData
  portalToken: string
}
